/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BrowserLinkIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABjElEQVR4nO2Uz0oDQQzGVxHxquhJfQT7AKLsVdnNJBWGpPXQRxCL9z3a0rt/8CT0LVRQi/gS9agXUbQvUMl2OlSKte3uSQwEhhn2++18ySQI/mOcsNbOG+I6IL8Ykm6WBOJnQ1JTTQ/QjazCZjhrHuCoXUTejKm0NWptJrjJ4A3STRVB5O1RazNBDgHyzsADkFt5iwPJffB3Akgecq8BcssD8vIciPcQeV1TOy83AKAcJ0ky+6NFGQGJauxYuwIoTUP8bpCfDHHVQ7OKh5XKAqC0gaQDxGdActc752oWQNJ3QAcbIJ8CSMFtzShEoVMCuK7fRVF5sVjcX/NWGznUQjvNc0P8+m3Yjdd+8hiG4ZzzXG25coINPY+RjxDLG4b4E0guJx7XiFxOfwqlCSgfTqzqzhtO71rh+hPeQ4X8dhMg6cRxadkB3gzKia5j4l1DfNC3Korsqto39csPegPyySDfakFTIEjBIN+oeCZhD3C2uBd8kbYoSttau5QLQB9R2jUobe0WLaj3fCC+AHuZf+6BfveZAAAAAElFTkSuQmCC)
 */
export const BrowserLinkIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M1 6a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm2 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M1 12a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1c0 .22-.23.37-.44.3a4.95 4.95 0 0 0-5.06 1.2l-4 4a4.93 4.93 0 0 0-1.42 3 .54.54 0 0 1-.53.5H4a3 3 0 0 1-3-3v-6Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M23.07 14.93a3.17 3.17 0 0 0-4.47 0l-.58.57a.74.74 0 0 0 1.04 1.04l.58-.57a1.7 1.7 0 0 1 2.4 2.4l-.58.57a.74.74 0 1 0 1.04 1.04l.57-.58a3.17 3.17 0 0 0 0-4.47ZM14.93 23.07a3.17 3.17 0 0 0 4.47 0l.58-.57a.74.74 0 1 0-1.04-1.04l-.58.57a1.7 1.7 0 0 1-2.4-2.4l.58-.57a.74.74 0 1 0-1.04-1.04l-.57.58a3.17 3.17 0 0 0 0 4.47Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M20.48 17.52c.29.3.29.76 0 1.05l-1.91 1.9a.74.74 0 0 1-1.05-1.04l1.91-1.9a.74.74 0 0 1 1.05 0Z"
        className={colorClass}
      />
    </svg>
  );
};
